import { alpha, Box, Paper, Stack, Typography } from "@mui/material";
import {
  ChevronRight as ChevronRightIcon,
  Google as GoogleIcon,
} from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";

/** Perfil com scroll automático até o card Google Health (`?focus=` funciona com HashRouter). */
export const PROFILE_GOOGLE_FIT_FOCUS = "google-fit";
export const PROFILE_GOOGLE_FIT_PATH = `/profile?focus=${PROFILE_GOOGLE_FIT_FOCUS}`;

interface FitnessGoogleAccountFooterProps {
  isConnected: boolean;
  /** Layout mais denso na seção embutida do dashboard mobile */
  compact?: boolean;
}

/**
 * Atalho ao Perfil na seção Google Health (conectar ou desvincular).
 */
export function FitnessGoogleAccountFooter({
  isConnected,
  compact = false,
}: FitnessGoogleAccountFooterProps) {
  const label = isConnected ? "Desvincular conta" : "Conectar conta";

  return (
    <Paper
      elevation={0}
      component={RouterLink}
      to={PROFILE_GOOGLE_FIT_PATH}
      sx={{
        display: "block",
        textDecoration: "none",
        color: "inherit",
        px: compact ? 1 : 1.25,
        py: compact ? 0.75 : 1,
        borderRadius: 1.5,
        border: "1px solid",
        borderColor: isConnected
          ? (t) => alpha(t.palette.error.main, 0.22)
          : "divider",
        bgcolor: isConnected
          ? (t) => alpha(t.palette.error.main, 0.04)
          : (t) => alpha(t.palette.primary.main, 0.03),
        transition: "border-color 0.15s ease, background-color 0.15s ease",
        "&:hover": {
          borderColor: isConnected ? "error.main" : "primary.main",
          bgcolor: isConnected
            ? (t) => alpha(t.palette.error.main, 0.07)
            : (t) => alpha(t.palette.primary.main, 0.06),
        },
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Box
          sx={{
            width: compact ? 24 : 28,
            height: compact ? 24 : 28,
            flexShrink: 0,
            borderRadius: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: isConnected
              ? "linear-gradient(135deg, #4285F4 0%, #34A853 50%, #FBBC05 75%, #EA4335 100%)"
              : (t) => alpha(t.palette.grey[400], 0.35),
          }}
        >
          <GoogleIcon
            sx={{
              fontSize: compact ? 13 : 15,
              color: isConnected ? "white" : "grey.600",
            }}
          />
        </Box>

        <Typography
          variant="body2"
          fontWeight={600}
          sx={{
            flex: 1,
            minWidth: 0,
            fontSize: compact ? "0.8125rem" : "0.875rem",
            color: isConnected ? "error.dark" : "text.primary",
          }}
        >
          {label}
        </Typography>

        <ChevronRightIcon
          sx={{
            flexShrink: 0,
            fontSize: compact ? 18 : 20,
            color: isConnected ? "error.main" : "text.secondary",
          }}
        />
      </Stack>
    </Paper>
  );
}
